exports.onRouteUpdate = ({ location }) => {
  // on route change scroll to top of page
  if (typeof window !== `undefined`) { window.scrollTo(0, 0)}
}

exports.shouldUpdateScroll = args => {
   return false;
};